// src/types/index.ts
var PreferenceScope = /* @__PURE__ */ ((PreferenceScope2) => {
  PreferenceScope2["SYSTEM_DEFAULT"] = "SYSTEM_DEFAULT";
  PreferenceScope2["TENANT_DEFAULT"] = "TENANT_DEFAULT";
  PreferenceScope2["ROLE_DEFAULT"] = "ROLE_DEFAULT";
  PreferenceScope2["USER_OVERRIDE"] = "USER_OVERRIDE";
  return PreferenceScope2;
})(PreferenceScope || {});
var ContextType = /* @__PURE__ */ ((ContextType2) => {
  ContextType2["GLOBAL"] = "GLOBAL";
  ContextType2["PAGE"] = "PAGE";
  ContextType2["VIEW"] = "VIEW";
  ContextType2["WIDGET"] = "WIDGET";
  ContextType2["WORKSPACE"] = "WORKSPACE";
  return ContextType2;
})(ContextType || {});
var DocumentState = /* @__PURE__ */ ((DocumentState2) => {
  DocumentState2["DEFAULTS_ONLY"] = "DEFAULTS_ONLY";
  DocumentState2["CACHED"] = "CACHED";
  DocumentState2["SYNCED"] = "SYNCED";
  DocumentState2["OPTIMISTIC"] = "OPTIMISTIC";
  DocumentState2["CONFLICT"] = "CONFLICT";
  DocumentState2["DEGRADED"] = "DEGRADED";
  DocumentState2["LOADING"] = "LOADING";
  DocumentState2["STALE"] = "STALE";
  return DocumentState2;
})(DocumentState || {});
var MergeStrategy = /* @__PURE__ */ ((MergeStrategy2) => {
  MergeStrategy2["REPLACE"] = "REPLACE";
  MergeStrategy2["ARRAY_CONCAT"] = "ARRAY_CONCAT";
  MergeStrategy2["DEEP_MERGE"] = "DEEP_MERGE";
  return MergeStrategy2;
})(MergeStrategy || {});

export {
  PreferenceScope,
  ContextType,
  DocumentState,
  MergeStrategy
};
//# sourceMappingURL=chunk-VYSGOHAZ.js.map